import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=6279703b&scoped=true"
import script from "./trade.vue?vue&type=script&lang=js"
export * from "./trade.vue?vue&type=script&lang=js"
import style0 from "./trade.vue?vue&type=style&index=0&id=6279703b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6279703b",
  null
  
)

export default component.exports